export class Data {
  origin_template_id: string = '';
  document_id: string = '';
  document_name: string = '';
  document_owner_email: string = '';
  annotations: any = [];
  invite_message_subject: string = '';
  invite_message_body: string = '';
  roles: any = [];
  routing_details: any = [];
  document_group_active: boolean = false;
  self_signer: boolean = false;
  sn_email: string = '';
  template_setting: any = [];
  using_template_setting: boolean = false;
  origin_view: string = '';

  clear() {
    this.origin_template_id = '';
    this.document_id = '';
    this.document_owner_email = '';
    this.invite_message_subject = '';
    this.invite_message_body = '';
    this.annotations = [];
    this.self_signer = false;
    this.origin_view = '';
  }
}

export class DocumentGroup {
  document_group_data: any = [];
  template_ids: any = [];
  document_group_id: string = '';
  document_group_name: string = '';
  documents: Array<Document> = new Array<Document>();
  annotations: any = [];
}

class Document {
  id: string = '';
  document_name: string = '';
  roles: any = [];
}

export class Salesforce {
  sf_user_id: string = '';
  sf_org_id: string = '';
  sf_token: string = '';
  sf_refresh: string = '';
  instance_url: string = '';
  record_type: string = '';
  record_id: string = '';
  location_url: string = '';
  view: string = '';
  context: string = '';
  proxy_url: string = '';
  is_maintenance: boolean = false;
}

export class OrgAdminSettings {
  sf_org_id: string;
  is_not_save_document: boolean;
  is_save_as_attachment: boolean;
  is_save_as_file: boolean;
}
